<json-editor [options]="editorOptions" [formControl]="formControl" class="Json-editor flex-1"></json-editor>
<!-- <mat-form-field style="width: 100%">
  <textarea matInput [formControl]="control" style="height: 500px"></textarea>
</mat-form-field> -->
